import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['codeInput', 'newNameSection', 'studentIdField', 'submitButton']

  connect() {
    if (this.hasCodeInputTarget) {
      this.codeInputTarget.addEventListener('input', this.formatCode.bind(this))
    }
  }

  formatCode(event) {
    const input = event.target
    // Strip non-alpha, uppercase, limit to 8 chars
    let value = input.value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 8)
    // Insert hyphen after 4th character for display
    if (value.length > 4) {
      value = `${value.slice(0, 4)}-${value.slice(4)}`
    }
    input.value = value
  }

  selectStudent(event) {
    const studentId = event.target.value
    if (this.hasNewNameSectionTarget) {
      this.newNameSectionTarget.classList.toggle('hidden', !!studentId)
    }
  }

  showNewNameForm(event) {
    event.preventDefault()
    if (this.hasNewNameSectionTarget) {
      this.newNameSectionTarget.classList.remove('hidden')
    }
    if (this.hasStudentIdFieldTarget) {
      this.studentIdFieldTarget.value = ''
    }
  }
}
